import { PURGE } from 'redux-persist'
import { Types } from 'reducers/Auth'

const purgeOnLogoutMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type === Types.LOGOUT) {
      dispatch({ type: PURGE, result: () => null })
    }
    return next(action)
  }

export default purgeOnLogoutMiddleware
